module.exports = __webpack_public_path__ + "img/share-product.cecab40.svg";